import React from 'react'
import BannerImage from "../assets/BannerImage.jpg";
import WhyUs from '../Components/WhyUs';
import Stats from '../Components/Stats';
import GetInTouch from '../Components/GetInTouch';

const WhyChooseUs = () => {
  return (
    <>
      <div className='relative -z-50'>
            <div className="absolute w-full h-[300px]">
                <img src={BannerImage} alt="WhyChooseUs" className="object-cover w-full h-[300px] opacity-95" />
            </div>
            <div className="relative flex  bg-gray-800 opacity-55">
                <div className="flex justify-start mx-12 items-center leading-8 w-full h-[300px]">
                    <h1 className=" font-bold text-5xl md:text-5xl text-white">Why Choose Us?</h1>
                    {/* <span><Link className='text-white' to='/'>Home</Link></span> */}
                </div>
            </div>
            </div>
            <WhyUs />
            <Stats />
            <GetInTouch />
    </>
  )
}

export default WhyChooseUs
